module.exports = "/subscriptions/assets/0294c7c0604741cd50de471c6a084045.png";